import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import React from "react";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { useRouterContext } from "../../../../context/RouterContext";
import buttonStyles from "../../../shared/components/EffektButton/EffektButton.module.scss";
import { getHref, isAbsoluteUrl, LinkType } from "../Links/Links";
import { isSafeHref } from "./isSafeHref";
import styles from "./StandaloneButton.module.scss";
export const StandaloneButton: React.FC<{
  links?: (LinkType | NavLink)[];
}> = t0 => {
  const $ = _c(15);
  const {
    links
  } = t0;
  const {
    articlesPagePath,
    fundraisersPath
  } = useRouterContext();
  const link = links?.[0];
  if (!link) {
    return null;
  }
  let href;
  let isFundraiser;
  let openInNewTab;
  let t1;
  let t2;
  if ($[0] !== articlesPagePath || $[1] !== fundraisersPath || $[2] !== link) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      ({
        href,
        isFundraiser
      } = getHref(link, articlesPagePath, fundraisersPath));
      if (!isSafeHref(href)) {
        t2 = null;
        break bb0;
      }
      openInNewTab = link._type === "link" && link.newtab;
      t1 = isAbsoluteUrl(href) ? "a" : Link;
    }
    $[0] = articlesPagePath;
    $[1] = fundraisersPath;
    $[2] = link;
    $[3] = href;
    $[4] = isFundraiser;
    $[5] = openInNewTab;
    $[6] = t1;
    $[7] = t2;
  } else {
    href = $[3];
    isFundraiser = $[4];
    openInNewTab = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const LinkElement = t1;
  const t3 = isFundraiser ? false : undefined;
  const t4 = openInNewTab ? "_blank" : undefined;
  const t5 = openInNewTab ? "noopener noreferrer" : undefined;
  let t6;
  if ($[8] !== LinkElement || $[9] !== href || $[10] !== link.title || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={styles.wrapper}><LinkElement href={href} prefetch={t3} target={t4} rel={t5} className={`${buttonStyles.button} ${buttonStyles.buttonprimary} ${styles.button}`} data-cy="standalone-button">{link.title}</LinkElement></div>;
    $[8] = LinkElement;
    $[9] = href;
    $[10] = link.title;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};